<template>
    <div class="mp-header" v-show="showHeader">
        <a href="//m.sohu.com">
            <div class="fl back-home">
                <div class="fl ico icon-left"></div>
                <div class="fl logo"></div>
                <div class="fl t">首页</div>
            </div>
        </a>
    </div>
</template>
<script>
export default {
    props:{
        sub_title: {
            default : '',
            type: String
        }
    },
    data(){
        return {
            showHeader: true
        }
    },
    created(){
        if(!window.subData.hasHeader){
            this.showHeader = false;
            return;
        }
        let that = this;
    },
    methods: {

    }
}
</script>
<style lang="less">
@img_dir: "../assets/images";
@mph_h: 44px;
.mp-header{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: @mph_h;/*no*/
    z-index: 998;
    overflow: hidden;
    background-color: #fdd000;
    .back-home{
        float: left;
        height: 100%;
        .ico{
            font-size: 16px;/*no*/
            padding-left: 9px;
            padding-right: 5px;
            line-height: @mph_h;/*no*/
        }
        .logo{
            width: 40px;/*no*/
            height: 100%;
            background: url("@{img_dir}/sohu_text.png") no-repeat center 46%;
            background-size: contain;
        }
        .t{
            height: 100%;
            line-height: @mph_h;/*no*/
            font-size: 19px;/*no*/
        }
    }
    .sohu_tv{
        height: 100%;
        .stv-ico{
            width: 21px;/*no*/
            height: 100%;
            background: url("@{img_dir}/sohu_tv_icon.png") no-repeat center center;
            background-size: contain;
            margin-right: 3px;
        }
        .tv-name{
            padding-right: 13px;/*no*/
            line-height: @mph_h;/*no*/
            max-width: 6.5em;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 15px;/*no*/
            height: 100%;
        }
    }
    .header__l{
        .back-home{
            .sohu{
                background: url("@{img_dir}/sohu_text.png") no-repeat center center;
                background-size: contain;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/MpHeader.vue